import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CartoucheSansGroupeItem, CartouchesService } from '../../../services/cartouches.service';

@Component({
  selector: 'app-cartouches-livrees-sans-attribution-taches',
  imports: [CommonModule, RouterLink],
  templateUrl: './cartouches-livrees-sans-attribution-taches.component.html',
  styleUrl: './cartouches-livrees-sans-attribution-taches.component.scss'
})
export class CartouchesLivreesSansAttributionTachesComponent implements OnInit {
  protected loading = false;
  protected error = '';
  protected items: CartoucheSansGroupeItem[] = [];

  constructor(
    private readonly cartouchesService: CartouchesService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.load();
  }

  protected refresh(): void {
    this.load();
  }

  private load(): void {
    this.loading = true;
    this.error = '';
    this.cdr.markForCheck();

    this.cartouchesService.listLivreesSansGroupeAmorces().subscribe({
      next: (items: CartoucheSansGroupeItem[]) => {
        this.items = items;
        this.loading = false;
        this.cdr.markForCheck();
      },
      error: (err: HttpErrorResponse) => {
        this.items = [];
        this.error = this.getErrorMessage(err);
        this.loading = false;
        this.cdr.markForCheck();
      }
    });
  }

  private getErrorMessage(err: HttpErrorResponse): string {
    if (typeof err.error === 'string' && err.error.trim()) {
      return err.error;
    }
    if (err.error?.detail) {
      return String(err.error.detail);
    }
    if (err.error?.message) {
      return String(err.error.message);
    }
    return err.statusText || 'Erreur inconnue';
  }
}